import React from 'react';

const Button = ({ text, cb, active }) => {
  const className = 'App-button ' + (active ? 'btn-active' : '');
  
  return (<button className={className} onClick={cb}>{text}</button>);
};

export default Button;